var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70.17 172.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#916657;}.cls-2{fill:#232323;}.cls-3{fill:#0e5279;}.cls-4{fill:#004568;}.cls-5{fill:#1199a1;}.cls-6{fill:#14adb2;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Female_03b",
    "data-name": "Staff_Female_03b",
    viewBox: "0 0 70.17 172.54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.14,63.63l-6.66,2S1.5,68.28,1.83,69s4,0,4,0L0,72.44A4.8,4.8,0,0,0,.83,75.1c.83,1,7.32.83,9.15-.33s7.48-7.65,7.48-7.65l6.65-4.66L17.62,58.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.69,159.06s1.5,2.66,1.33,4.16-4.48,4.68-8.31,7c-4.16,2.5-8.48,3-10.48,1.5s5.65-8,9-10.81S60.69,159.06,60.69,159.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.7,152.9s1,2.9.53,4.34-4.41,2.62-8.48,4.48-9.29,3.51-11,1.67,6.81-7.32,10.24-10.27S42.7,152.9,42.7,152.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64,116.83c-.66,16.63-1.49,38.58-1.49,42.4s-12.47,6.82-12.64.17-1-38.91-1-38.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.59,115.52s.23,34.77.5,37.25c.34,3,10.48,2.82,10.48-1.33,0-6.32,3.16-36.92,3.16-36.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.23,28c-3.16-1.05-5.16-.33-9.65,6.65s-7.31,12.47-8.64,14.47S13.7,60.47,11.81,62.79c-2.17,2.66,2.78,7.84,6.65,5.49s15.16-11.51,17-13.3C37.41,53,53.21,31,44.23,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.37,28.21C61,29.45,66.67,34.36,67.17,40s-1.83,26.61-1.83,31.43,2.83,11.31,3,20.45.33,21,.33,27.77C59,125.15,52.38,125.31,47.22,125s-16.46-3.66-16.46-3.66c-.17-17.29,3.49-37.08,4-45.06s1.5-15.79.83-18.29-3.32-4.15-3-7.31,4.16-13.31,6.15-18S44.23,26.71,53.37,28.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.4,10.42c-1.33,4.76-1.66,13.13-1,15.46S42.9,29,45.89,29.21c.33,3,1.33,10,1.33,10,6-3,10-10.14,10-10.14l-.5-4c4-.83,8-5,8.48-11.8S61,2.11,54,1.77,41.9,5.1,40.4,10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.88,83.25s-5.49,2-7,3.32-2.66,2.33-3.66,3.33-.5,2.32,1.5,1.49,3-1.33,3-1.33-3.26,4.6-4,5.82c-1,1.66.5,2.33,2.33,2.83s6.31-3,7.48-4.49,6-9.31,6-9.31l3.5-4-5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,34.86c3.67-1.11,6.32,4.49,6.16,12.8s-.34,16-1.83,20.79-3.83,7.65-6.15,10.8a57.48,57.48,0,0,1-6.82,8.15c-2.09,1.95-8.48-2.16-6.15-5.49s9.31-14.46,9.31-17.45S54.7,37.69,64,34.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.26,4.67A6.74,6.74,0,0,0,60.76.38a5.85,5.85,0,0,0-1.57.87c-7.54-2.8-19-.28-20.62,8.17C37.48,15,48.88,14.91,48.88,14.91a14.78,14.78,0,0,0,2.33,4.49c.83-2.83,5.82-3.16,6.15-.17s-1.49,4.66-2.82,5S56,27.05,56,27.05s8.32-.34,10.31-9.81a23.37,23.37,0,0,0,.53-4.41A6.9,6.9,0,0,0,69.26,4.67Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("use", {
    width: 70.17,
    height: 172.54,
    xlinkHref: "#Staff_Female_03b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff2A);
export default __webpack_public_path__ + "static/media/staff-2-a.75e839e3dba151787ca18d301f3f1bda.svg";
export { ForwardRef as ReactComponent };